import styled from "styled-components";

export const InfoContainer = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	text-align: left;
`;

export const InfoLabel = styled.label`
	font-family: "Montserrat";
	font-size: 14px;
	font-weight: 500;
	line-height: 26.6px;

	& .label__icon-container {
		display: flex;
		align-items: center;
	}
`;
